import { render } from "./SkillIconAutoCategory.vue?vue&type=template&id=bf8fff16"
import script from "./SkillIconAutoCategory.vue?vue&type=script&lang=js"
export * from "./SkillIconAutoCategory.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__